import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const UserDashboardAppLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "UserDashboard" */
      './UserDashboardApp.dynamic'
    ),
  loading: LoadingPageLoadable,
});
